// ── UK MARKET HELPERS ──
var MSK_EU_TO_UK = {'22':'5','22.5':'5.5','23':'6','23.5':'6.5','24':'7','24.5':'7.5','25':'8','25.5':'8.5','26':'9','26.5':'9','27':'9.5','27.5':'10','28':'10.5','28.5':'11','29':'11','29.5':'11.5','30':'12','30.5':'12','31':'12.5','31.5':'13','32':'13','32.5':'13.5','33':'1','33.5':'1.5','34':'1.5','34.5':'2','35':'2.5','36':'3.5','36.5':'4','37':'4','37.5':'4.5','38':'5','38.5':'5.5','39':'6','39.5':'6.5','40':'6.5','40.5':'7','41':'7.5','41.5':'7.5','42':'8','42.5':'8.5','43':'9','43.5':'9.5','44':'9.5','44.5':'10','45':'10.5','46':'11.5','47':'12'};
function mskIsUK() { var _c=window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active; return _c==='GBP'||_c==='AUD'||_c==='NZD'; }
function mskCurrencySymbol() { var _c=window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active; if(_c==='GBP')return'£'; if(_c==='AUD')return'A$'; if(_c==='NZD')return'NZ$'; return'€'; }
function mskDisplaySize(euSize) {
  var eu = String(euSize).replace(/^Size/i,'').trim();
  if (mskIsUK() && MSK_EU_TO_UK[eu]) return 'UK ' + MSK_EU_TO_UK[eu];
  return euSize;
}

// ── HEADER SCROLL (throttled) ──
var _scrollTick = false;
window.addEventListener('scroll', function() {
  if (_scrollTick) return;
  _scrollTick = true;
  requestAnimationFrame(function() {
    document.getElementById('header').classList.toggle('scrolled', window.scrollY > 40);
    var btn = document.getElementById('scroll-top');
    if (btn) btn.classList.toggle('visible', window.scrollY > 400);
    var stickyAtc = document.getElementById('sticky-atc');
    var addBtn = document.getElementById('btn-add-cart');
    if (stickyAtc && addBtn) stickyAtc.classList.toggle('visible', addBtn.getBoundingClientRect().bottom < 0);
    _scrollTick = false;
  });
}, {passive: true});

// ── MOBILE MENU ──
function toggleMenu() {
  var nav = document.getElementById('mobile-nav');
  var btn = document.querySelector('.menu-toggle');
  var open = nav.classList.toggle('show');
  if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  document.body.style.overflow = open ? 'hidden' : '';
}

// ── SEARCH ──
function toggleSearch() {
  const ov = document.getElementById('search-overlay');
  const open = ov.classList.contains('show');
  ov.classList.toggle('show');
  if (!open) setTimeout(() => document.getElementById('search-input').focus(), 100);
  else document.getElementById('search-results').innerHTML = '';
}
function closeSearch(e) {
  if (e.target === document.getElementById('search-overlay')) toggleSearch();
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    if (document.getElementById('search-overlay').classList.contains('show')) toggleSearch();
    if (document.getElementById('mobile-nav').classList.contains('show')) toggleMenu();
    if (document.getElementById('quick-shop-modal') && document.getElementById('quick-shop-modal').classList.contains('show')) closeQuickShopDirect();
  }
});

// ── LIVE SEARCH AUTOCOMPLETE ──
(function() {
  var searchTimer = null;
  document.addEventListener('DOMContentLoaded', function() {
    var input = document.getElementById('search-input');
    var results = document.getElementById('search-results');
    if (!input || !results) return;

    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { results.innerHTML = ''; return; }
      searchTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<div class="search-no-results">' + mskT('search_no_results') + ' "' + q + '"</div>';
              return;
            }
            results.innerHTML = products.map(function(p) {
              var img = p.image ? '<img src="' + p.image + '" alt="">' : '<div class="search-res-no-img">' + (p.vendor||'').slice(0,2).toUpperCase() + '</div>';
              var price = p.price ? (parseFloat(p.price) / 100).toFixed(0) + ' ' + mskCurrencySymbol() : '';
              return '<a class="search-res-item" href="' + p.url + '" onclick="toggleSearch()">'
                + '<div class="search-res-img">' + img + '</div>'
                + '<div class="search-res-info">'
                + '<div class="search-res-title">' + p.title + '</div>'
                + '<div class="search-res-meta">' + (p.vendor||'') + (price ? ' — ' + price : '') + '</div>'
                + '</div></a>';
            }).join('');
          })
          .catch(function() { results.innerHTML = ''; });
      }, 250);
    });
  });
})();

// ── CART DRAWER ──
function toggleCart() {
  const ov = document.getElementById('cart-overlay');
  const open = ov.classList.contains('show');
  ov.classList.toggle('show');
  document.body.style.overflow = open ? '' : 'hidden';
  if (!open) { updateCartDrawer(); mskDismissAddedPopup(); }
}
function closeCartClick(e) {
  if (e.target === document.getElementById('cart-overlay')) toggleCart();
}

// Formatage monetaire multi-marche partage (panier + total + sous-total + remise) :
// meme logique que l'ancien calcul du total, appliquee a n'importe quel montant en
// centimes EUR issu de l'objet cart (evite toute divergence entre les lignes affichees).
function mskFormatCartMoney(cents, cart) {
  var p = cents / 100;
  var s = mskCurrencySymbol(), c = window.MSK_COUNTRY || '', pa = window.location.pathname;
  var au = s === 'A$' || s === 'NZ$' || c === 'AU' || c === 'NZ' || pa.indexOf('/en-au') === 0 || pa.indexOf('/en-nz') === 0;
  var uk = s === '£' || c === 'GB' || pa.indexOf('/en-gb') === 0;
  var needConv = (!cart.currency || cart.currency === 'EUR');
  var rate = needConv ? ((window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1) : 1;
  if (au) { var auSym = (c === 'NZ' || pa.indexOf('/en-nz') === 0) ? 'NZ$' : 'A$'; return auSym + Math.round(p * rate); }
  if (uk) { return '£' + (needConv ? Math.round(p) : Math.round(p * 1.1111)); }
  if (s === '€') return p.toFixed(2) + ' €';
  return s + p.toFixed(2);
}

function updateCartDrawer() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(renderCartDrawer);
}

function renderCartDrawer(cart) {
  const body = document.getElementById('cart-body');
  const foot = document.getElementById('cart-foot');
  const badge = document.getElementById('cart-badge');

  // Update badge
  const count = cart.item_count;
  badge.textContent = count > 0 ? count : '';

  if (!cart.items || cart.items.length === 0) {
    body.innerHTML = `<div class="cart-empty"><div class="cart-empty-icon">👟</div><p>${mskT('cart_empty')}</p><a href="/collections/all" class="btn-primary" style="margin-top:1rem">${mskT('cart_explore')}</a></div>`;
    foot.style.display = 'none';
    return;
  }

  foot.style.display = 'flex';

  body.innerHTML = cart.items.map((item, idx) => `
    <div class="cart-item">
      <div class="cart-item-img">
        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
      </div>
      <div class="cart-item-info">
        <div class="cart-item-title">${item.product_title}</div>
        <div class="cart-item-meta">${item.variant_title !== 'Default Title' ? mskT('size_prefix') + mskDisplaySize(item.variant_title) : ''}</div>
        <div class="cart-item-row">
          <div class="cart-item-price">${mskFormatCartMoney(item.final_line_price, cart)}</div>
          <div class="cart-qty-ctrl">
            <button onclick="updateQty('${item.key}', ${item.quantity - 1}, this)" ${item.quantity <= 1 ? 'style="opacity:.3"' : ''}>−</button>
            <span>${item.quantity}</span>
            <button onclick="updateQty('${item.key}', ${item.quantity + 1}, this)">+</button>
          </div>
        </div>
        <button class="cart-remove" onclick="updateQty('${item.key}', 0, this)">${mskT('cart_remove')}</button>
      </div>
    </div>`).join('');

  // Sous-total (avant remise) : total des lignes avant toute remise, calcule par Shopify.
  document.getElementById('cart-subtotal').textContent = mskFormatCartMoney(cart.original_total_price, cart);

  // Remises : on distingue les remises produits/commande (target_type line_item, deja
  // deduites de cart.total_price) des remises livraison (target_type shipping_line,
  // dont le montant n'existe pas encore au stade panier : aucune ligne de livraison
  // n'a ete calculee avant le checkout — voir note ci-dessous).
  var appliedCodes = (cart.discount_codes || []).filter(function(c) { return c.applicable; });
  var lineItemAllocations = cart.cart_level_discount_applications || [];
  var lineItemDiscountCents = 0;
  var lineItemTitles = [];
  lineItemAllocations.forEach(function(entry) {
    var app = entry.discount_application || entry;
    if (app.target_type === 'shipping_line') return;
    lineItemDiscountCents += (entry.amount != null ? entry.amount : (app.total_allocated_amount || 0));
    if (app.title && lineItemTitles.indexOf(app.title) === -1) lineItemTitles.push(app.title);
  });

  var discountLine = document.getElementById('cart-discount-line');
  if (lineItemDiscountCents > 0) {
    document.getElementById('cart-discount-label').textContent = (lineItemTitles[0] || mskT('promo_code_applied')) + ' :';
    document.getElementById('cart-discount-amount').textContent = '-' + mskFormatCartMoney(lineItemDiscountCents, cart);
    discountLine.style.display = 'flex';
  } else {
    discountLine.style.display = 'none';
  }

  // Codes acceptes par Shopify (discount_codes[].applicable) mais qui ne reduisent pas
  // les produits (pas d'allocation line_item) : le plus souvent un code livraison —
  // Shopify ne calcule le montant de la remise livraison qu'a l'etape de livraison du
  // checkout (aucune ligne de transport n'existe encore dans le panier). On l'indique
  // clairement au lieu d'afficher un montant invente.
  var shippingLine = document.getElementById('cart-shipping-discount-line');
  var codesWithoutProductEffect = appliedCodes.filter(function(c) {
    return lineItemTitles.map(function(t) { return t.toUpperCase(); }).indexOf(c.code.toUpperCase()) === -1;
  });
  if (codesWithoutProductEffect.length > 0) {
    shippingLine.textContent = '✓ ' + codesWithoutProductEffect.map(function(c){return c.code;}).join(', ') + ' — ' + mskT('cart_discount_shipping_note');
    shippingLine.style.display = 'block';
  } else {
    shippingLine.style.display = 'none';
  }

  // Total apres remise produits (cart.total_price = calcul Shopify reel, pas simule).
  // La livraison n'est jamais incluse dans ce total panier, avec ou sans code.
  document.getElementById('cart-total').textContent = mskFormatCartMoney(cart.total_price, cart);

  // Etat du bloc "code promo" : reflete l'etat REEL du panier cote serveur (persiste
  // automatiquement a la fermeture/reouverture, puisque relu depuis /cart.js a chaque
  // ouverture, sans copie locale desynchronisable).
  var row = document.getElementById('drawer-discount-row');
  var ok = document.getElementById('drawer-discount-ok');
  if (appliedCodes.length > 0) {
    row.style.display = 'none';
    ok.style.display = 'flex';
    document.getElementById('drawer-discount-ok-text').textContent = mskT('promo_code_applied') + ' : ' + appliedCodes.map(function(c){return c.code;}).join(', ');
  } else {
    row.style.display = 'flex';
    ok.style.display = 'none';
  }

  // Promo message
  const promoMsg = document.getElementById('cart-promo-msg');
  if (count >= 2) {
    promoMsg.innerHTML = mskT('cart_promo_ok');
  } else {
    promoMsg.innerHTML = mskT(2 - count === 1 ? 'cart_promo_need1' : 'cart_promo_need2');
  }
}

// Envoie le code au panier Shopify reel (Cart AJAX API, parametre "discount" de
// /cart/update.js) : validation et calcul de la remise effectues par Shopify, jamais
// simules cote client. code === '' retire tous les codes actifs du panier.
function mskPostCartDiscount(code) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: code })
  }).then(function(r) { return r.json(); });
}

function applyDrawerDiscount() {
  var input = document.getElementById('drawer-discount-input');
  var code = input.value.trim();
  if (!code) return;
  var btn = document.getElementById('drawer-discount-btn');
  var errEl = document.getElementById('drawer-discount-error');
  errEl.style.display = 'none';
  errEl.textContent = '';
  btn.disabled = true;
  var originalLabel = btn.textContent;
  btn.textContent = mskT('promo_code_applying');

  mskPostCartDiscount(code)
    .then(function(cart) {
      btn.disabled = false;
      btn.textContent = originalLabel;
      var entry = (cart.discount_codes || []).filter(function(c) {
        return c.code.toUpperCase() === code.toUpperCase();
      })[0];
      if (entry && entry.applicable) {
        input.value = '';
        renderCartDrawer(cart);
      } else {
        // Code invalide, expire ou non applicable a ce panier : Shopify ne l'a pas
        // applique (discount_codes[].applicable === false). On ne montre jamais de
        // succes et le total reste celui, inchange, renvoye par Shopify.
        errEl.textContent = mskT('promo_code_invalid');
        errEl.style.display = 'block';
        renderCartDrawer(cart);
      }
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = originalLabel;
      errEl.textContent = mskT('promo_code_error');
      errEl.style.display = 'block';
    });
}

function removeDrawerDiscount() {
  mskPostCartDiscount('').then(renderCartDrawer);
}

function updateQty(variantId, qty, btn) {
  if (btn) btn.disabled = true;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(err) { throw err; });
    return r.json();
  })
  .then(function(cart) {
    updateCartDrawer();
    if (typeof renderCartPage === 'function') renderCartPage(cart);
  })
  .catch(function(err) {
    if (btn) btn.disabled = false;
    updateCartDrawer();
    if (typeof renderCartPage === 'function') { fetch('/cart.js').then(function(r){return r.json();}).then(renderCartPage); }
    var msg = (err && err.description) ? err.description : mskT('stock_limited');
    showCartError(msg);
  });
}

function showCartError(msg) {
  var c = document.getElementById('toast-container');
  var t = document.createElement('div');
  t.className = 'toast toast-error';
  t.innerHTML = '<div><strong style="font-size:.85rem;display:block;color:#ff6b6b">' + mskT('stock_limited') + '</strong><span style="font-size:.75rem;color:var(--gray)">' + msg.slice(0, 70) + '</span></div>';
  c.appendChild(t);
  requestAnimationFrame(function() { requestAnimationFrame(function() { t.classList.add('show'); }); });
  setTimeout(function() { t.classList.remove('show'); setTimeout(function() { t.remove(); }, 300); }, 4000);
}

// Init cart badge on page load
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.getElementById('cart-badge');
      if (badge && cart.item_count > 0) badge.textContent = cart.item_count;
    });
});

// ── ADD TO CART POPUP ──
// Popup complete de confirmation d'ajout au panier : image, nom produit,
// bouton "continuer" (ferme, reste sur place) et bouton "panier" (vraie page /cart).
// N'apparait que sur un ajout reellement confirme par Shopify (appelant depuis un .then()
// de /cart/add.js). Ne se superpose jamais au panier lateral ouvert. Textes via mskT()
// pour rester corrects sur les marches non-FR (en-us, en-gb, en-au, de, es, it, nl...).
function mskDismissAddedPopup() {
  var t = document.querySelector('.toast-added');
  if (!t) return;
  t.classList.remove('show');
  if (t._mskKeyHandler) document.removeEventListener('keydown', t._mskKeyHandler);
  setTimeout(function() { if (t.parentNode) t.remove(); }, 300);
}

// Convertit une valeur en rem vers des pixels selon la taille de police racine reelle
// (evite de supposer 16px en dur si le theme change un jour la taille de base).
function mskRemToPx(remVal) {
  return remVal * (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16);
}

// Mesure la vraie zone de securite bas d'ecran (encoche/barre de gestes iOS) en pixels,
// puisque env(safe-area-inset-bottom) n'est pas lisible directement depuis JS.
function mskSafeAreaBottomPx() {
  var probe = document.createElement('div');
  probe.style.cssText = 'position:fixed;bottom:0;left:0;height:0;padding-bottom:env(safe-area-inset-bottom);visibility:hidden;pointer-events:none';
  document.body.appendChild(probe);
  var v = parseFloat(getComputedStyle(probe).paddingBottom) || 0;
  probe.remove();
  return v;
}

// Detecte, sans dependre d'un selecteur precis, tout bandeau fixe accroche au bas reel
// du viewport (bandeau cookies affiche, sticky ATC mobile, barre de previsualisation
// Shopify — cette derniere n'appartenant pas au thème, son balisage ne peut pas etre
// suppose stable). Cumule les bandeaux empiles pour ne jamais faire chevaucher la popup.
function mskBottomObstructionPx() {
  var total = 0;
  var probeX = Math.min(20, window.innerWidth - 1);
  for (var i = 0; i < 5; i++) {
    var probeY = window.innerHeight - total - 2;
    if (probeY < 0) break;
    var el = document.elementFromPoint(probeX, probeY);
    var hit = null;
    while (el && el !== document.documentElement) {
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed') {
        var rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.height < window.innerHeight * 0.6 && rect.bottom > window.innerHeight - total - 4) {
          hit = rect;
          break;
        }
      }
      el = el.parentElement;
    }
    if (!hit) break;
    total = window.innerHeight - hit.top;
  }
  return total;
}

// Positionne le conteneur des popups juste au-dessus de tout bandeau reellement present
// (cookies, barre de previsualisation Shopify...), sans jamais descendre sous la base
// (2rem + zone de securite iOS) quand rien ne l'obstrue.
function mskPositionToastContainer() {
  var container = document.getElementById('toast-container');
  if (!container) return;
  var base = mskRemToPx(2) + mskSafeAreaBottomPx();
  var obstruction = mskBottomObstructionPx();
  container.style.bottom = (obstruction > base ? obstruction + 12 : base) + 'px';
}

function mskShowAddedPopup(item) {
  var overlay = document.getElementById('cart-overlay');
  if (overlay && overlay.classList.contains('show')) return; // pas de superposition avec le panier lateral ouvert

  mskDismissAddedPopup();
  mskPositionToastContainer();

  var c = document.getElementById('toast-container');
  var t = document.createElement('div');
  t.className = 'toast toast-added';
  t.setAttribute('role', 'status');
  t.setAttribute('aria-live', 'polite');

  var imgSrc = item && item.image ? item.image : '';
  var name = item && (item.product_title || item.title) ? (item.product_title || item.title) : '';

  t.innerHTML =
    '<div class="toast-row">' +
      (imgSrc ? '<img class="toast-img" src="' + imgSrc + '" alt="">' : '') +
      '<div class="toast-info">' +
        '<div class="toast-title">' + mskT('toast_added') + '</div>' +
        '<div class="toast-product-name">' + name + '</div>' +
      '</div>' +
      '<button type="button" class="toast-close" aria-label="Fermer">✕</button>' +
    '</div>' +
    '<div class="toast-actions">' +
      '<button type="button" class="toast-btn toast-btn-secondary" data-action="continue">' + mskT('toast_continue') + '</button>' +
      '<a href="/cart" class="toast-btn toast-btn-primary" data-action="cart">' + mskT('toast_view_cart') + '</a>' +
    '</div>';

  c.appendChild(t);

  function onKey(e) { if (e.key === 'Escape') mskDismissAddedPopup(); }
  t._mskKeyHandler = onKey;
  document.addEventListener('keydown', onKey);
  t.querySelector('.toast-close').addEventListener('click', mskDismissAddedPopup);
  t.querySelector('[data-action="continue"]').addEventListener('click', mskDismissAddedPopup);

  requestAnimationFrame(function() { requestAnimationFrame(function() { t.classList.add('show'); }); });

  var focusBtn = t.querySelector('.toast-btn-secondary');
  if (focusBtn) focusBtn.focus();
}

// scroll-top and sticky-atc handled in main scroll listener above

// ── QUICK SHOP ──
function openQuickShop(e, btn) {
  e.preventDefault();
  e.stopPropagation();
  var title = btn.dataset.title;
  var image = btn.dataset.image || '';
  var price = btn.dataset.price || '';
  var url = btn.dataset.url;
  var variantStr = btn.dataset.variants || '';
  var variants = variantStr ? variantStr.split(';').map(function(v) {
    var p = v.split(':');
    return {id: p[0], title: p[1] || '', available: p[2] === '1'};
  }) : [];

  document.getElementById('qs-title').textContent = title;
  document.getElementById('qs-price').textContent = (window.MskPrice && price) ? window.MskPrice.display(parseFloat(price)) : price;
  document.getElementById('qs-img').src = image;
  document.getElementById('qs-link').href = url;

  var sizesEl = document.getElementById('qs-sizes');
  sizesEl.innerHTML = variants.map(function(v) {
    return '<button class="quick-sz-btn"'
      + (v.available ? '' : ' disabled')
      + ' onclick="quickAddToCart(' + v.id + ',\'' + title.replace(/'/g, "\\'") + '\',\'' + image + '\')">'
      + v.title + '</button>';
  }).join('');

  var modal = document.getElementById('quick-shop-modal');
  modal.classList.add('show');
  document.body.style.overflow = 'hidden';
}

function closeQuickShopDirect() {
  document.getElementById('quick-shop-modal').classList.remove('show');
  document.body.style.overflow = '';
}

function quickAddToCart(variantId, title, image) {
  var btns = document.querySelectorAll('#qs-sizes .quick-sz-btn');
  btns.forEach(function(b) { b.classList.add('adding'); b.disabled = true; });
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: parseInt(variantId), quantity: 1})
  })
  .then(function(r) { return r.json(); })
  .then(function(item) {
    closeQuickShopDirect();
    updateCartDrawer();
    mskShowAddedPopup(item);
  })
  .catch(function() {
    btns.forEach(function(b) { b.classList.remove('adding'); b.disabled = false; });
  });
}

// ── WISHLIST ──────────────────────────────────────────────────────────────
function getWishlist() {
  try { return JSON.parse(localStorage.getItem('msk_wishlist') || '[]'); } catch(e) { return []; }
}
function saveWishlist(list) {
  localStorage.setItem('msk_wishlist', JSON.stringify(list));
}
function updateWishlistBadge() {
  var list = getWishlist();
  var badge = document.getElementById('wishlist-badge');
  if (badge) { badge.textContent = list.length > 0 ? list.length : ''; }
  var btn = document.getElementById('wishlist-btn');
  if (btn) btn.classList.toggle('active', list.length > 0);
}
function toggleWishlistProduct(id, title, image, price, url) {
  var list = getWishlist();
  var idx = list.findIndex(function(p) { return p.id == id; });
  if (idx >= 0) {
    list.splice(idx, 1);
  } else {
    list.push({ id: id, title: title, image: image, price: price, url: url });
  }
  saveWishlist(list);
  updateWishlistBadge();
  updateWishlistButtons();
  renderWishlistBody();
}
function updateWishlistButtons() {
  var list = getWishlist();
  var ids = list.map(function(p) { return String(p.id); });
  document.querySelectorAll('[data-wishlist-id]').forEach(function(btn) {
    btn.classList.toggle('active', ids.indexOf(btn.dataset.wishlistId) >= 0);
  });
  // fiche produit
  var pp = document.getElementById('btn-wishlist-product');
  if (pp) {
    var pid = pp.dataset.pid;
    pp.classList.toggle('active', ids.indexOf(String(pid)) >= 0);
  }
}
function renderWishlistBody() {
  var body = document.getElementById('wishlist-body');
  if (!body) return;
  var list = getWishlist();
  if (list.length === 0) {
    body.innerHTML = '<div class="wishlist-empty"><div style="font-size:3rem;margin-bottom:1rem">🤍</div><p>Aucun favori pour l\'instant</p><a href="/collections/all" class="btn-primary" style="margin-top:1rem">Explorer le catalogue</a></div>';
    return;
  }
  body.innerHTML = list.map(function(p) {
    return '<div class="wishlist-item"><a href="'+p.url+'" class="wishlist-item-img"><img src="'+p.image+'" alt="'+p.title+'" loading="lazy"></a><div class="wishlist-item-info"><div class="wishlist-item-title">'+p.title+'</div><div class="wishlist-item-price">'+p.price+'</div></div><div class="wishlist-item-actions"><a href="'+p.url+'" class="wishlist-item-buy">Voir →</a><button class="wishlist-item-remove" onclick="toggleWishlistProduct(\''+p.id+'\',\''+p.title.replace(/'/g,"\'")+'\',' + '\''+p.image+'\',\''+p.price+'\',\''+p.url+'\')">Retirer</button></div></div>';
  }).join('');
}
function toggleWishlist() {
  var ov = document.getElementById('wishlist-overlay');
  if (!ov) return;
  var open = ov.classList.toggle('show');
  if (open) { renderWishlistBody(); document.body.style.overflow = 'hidden'; }
  else document.body.style.overflow = '';
}
// Initialisation au chargement
document.addEventListener('DOMContentLoaded', function() {
  updateWishlistBadge();
  updateWishlistButtons();
  // Marquer le bouton wishlist sur fiche produit
  var pp = document.getElementById('btn-wishlist-product');
  if (pp) {
    var list = getWishlist();
    var ids = list.map(function(p) { return String(p.id); });
    pp.classList.toggle('active', ids.indexOf(String(pp.dataset.pid)) >= 0);
  }
  // Ajouter data-wishlist-id aux boutons de cards
  document.querySelectorAll('.prod-wishlist-btn').forEach(function(btn) {
    var onclick = btn.getAttribute('onclick') || '';
    var m = onclick.match(/toggleWishlistProduct\('(\d+)'/);
    if (m) btn.dataset.wishlistId = m[1];
  });
  updateWishlistButtons();
});


/* CURRENCY CONVERTER — retire le 2026-08-29, remplace par le module universel assets/msk-price.js */


/* UK/AU/NZ MARKET FIX — stops MutationObserver loop from cached product.liquid */
(function(){
  var curr = window.MSK_CURRENCY || (window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'';
  if(curr!=='GBP'&&curr!=='AUD'&&curr!=='NZD')return;
  var euToUk={'35':'2.5','36':'3.5','36.5':'4','37':'4','37.5':'4.5','38':'5','38.5':'5.5','39':'6','39.5':'6.5','40':'6.5','40.5':'7','41':'7.5','41.5':'7.5','42':'8','42.5':'8.5','43':'9','43.5':'9.5','44':'9.5','44.5':'10','45':'10.5','46':'11.5','47':'12'};
  var ukReviews=[
    {stars:'★★★★★',text:'"Incredible quality, exactly as shown in the photos. Delivery took a bit longer but absolutely worth the wait. Highly recommend!"',author:'James T.',city:'London'},
    {stars:'★★★★★',text:'"Super happy with my order, the shoes look stunning. True to size. Already ordered a second pair."',author:'Marcus B.',city:'Manchester'},
    {stars:'★★★★★',text:'"Unbeatable value. My friends think they\'re real and they cost 5x less. Customer service was great too."',author:'Danny A.',city:'Birmingham'},
    {stars:'★★★★☆',text:'"Beautiful pair, exactly as described. Took off one star as delivery was slightly longer than expected, but quality is top notch."',author:'Sarah D.',city:'Leeds'},
    {stars:'★★★★★',text:'"Second order from MySportKits. Always reliable. The TN are perfect, can\'t fault them."',author:'Jack M.',city:'Liverpool'}
  ];
  function fix(){
    // 1. Description — set once, then rename class to neutralise cached IIFE loop
    var desc=document.querySelector('.product-desc');
    if(desc&&!desc.hasAttribute('data-en-done')){
      desc.textContent='Premium quality sneakers. Comfortable fit, durable materials. Ships worldwide in 7-14 business days.';
      desc.setAttribute('data-en-done','1');
      desc.classList.remove('product-desc');
      desc.classList.add('product-desc-en');
    }
    // 2. Size label — set once, then rename ID to neutralise cached IIFE loop
    var lbl=document.getElementById('size-label-main');
    if(lbl&&!lbl.hasAttribute('data-label-done')){
      lbl.textContent='UK Size';
      lbl.setAttribute('data-label-done','1');
      lbl.id='size-label-en';
    }
    // 3. Convert size buttons (only unconverted ones)
    document.querySelectorAll('.size-btn:not([data-eu-size])').forEach(function(btn){
      var eu=btn.textContent.trim();
      if(euToUk[eu]!==undefined){btn.setAttribute('title','EU '+eu);btn.textContent=euToUk[eu];btn.setAttribute('data-eu-size',eu);}
    });
    // 4. Replace reviews once
    var grid=document.querySelector('.reviews-grid');
    if(grid&&!grid.getAttribute('data-uk-done')){
      grid.setAttribute('data-uk-done','1');
      var h='';ukReviews.forEach(function(r){h+='<div class="review-card"><div class="review-stars">'+r.stars+'</div><div class="review-text">'+r.text+'</div><div class="review-author">'+r.author+' <span class="review-location">— '+r.city+'</span></div></div>';});
      grid.innerHTML=h;
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fix);}else{fix();}
})();

/* CURRENCY CONVERTER (minifie) — retire le 2026-08-29, remplace par assets/msk-price.js */
